import type { AgentMessage } from "../ai-chat-message-utils";
import { UserMessage } from "./UserMessage";
import { AssistantMessage } from "./AssistantMessage";

interface ChatMessageProps {
  message: AgentMessage;
  onQuestionSelected?: (question: string) => void;
  latestExchangeAnchorRef?: React.Ref<HTMLDivElement>;
}

export const ChatMessage = ({
  message,
  onQuestionSelected,
  latestExchangeAnchorRef,
}: ChatMessageProps) => {
  switch (message.role) {
    case "user":
      return (
        <UserMessage
          message={message}
          latestExchangeAnchorRef={latestExchangeAnchorRef}
        />
      );
    case "assistant":
      return (
        <AssistantMessage message={message} onQuestionSelected={onQuestionSelected} />
      );
    default:
      return null;
  }
};
